import { AnimatedTestimonials } from "./ui/animated-testimonial";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

export function AnimatedTestimonialsDemo() {
  const testimonials = [
    {
      name: "Abhishak",
      designation: "Professional Photographer",
      src: `https://ui-avatars.com/api/?name=A&background=random&size=256`,
      rating: 5,
      quote:
        "Nikon's proper Authorized service centre we can totally depend on them for service and cleaning. Working staff are also well mannered and respond to the queries immediately. I gave nikon d850 and almost 5 lenses to service and everything was perfectly fine.",
    },
    {
      name: "Uncharted Travel Photography",
      designation: "Photojournalist",
      src: `https://ui-avatars.com/api/?name=U&background=random&size=256`,
      rating: 5,
      quote:
        "Had my 600mm f4 dropped and broke along with my Nikon D750. They did a great job by fixing both with utmost precision. I am extremely satisfied with their work and the fact that they have always kept their time and been extremely transparent with the progress of service. I've serviced multiple lenses most of them to clean fungus, I have never had any complaint with them so far. Thank you so much for fixing an extremely complicated lens like the 600mm f4.",
    },
    {
      name: "Vinod Venugopal",
      designation: "Wedding Photographer",
      src: `https://ui-avatars.com/api/?name=V&background=random&size=256`,
      rating: 5,
      quote:
        "We had been to the Nikon service center to get the lens and camera serviced. It was quite a busy day for them, but we requested them to service the camera and give it back as soon as possible. We had travelled for more than 50 kms to reach the service center from Chengalpattu and reached the place late afternoon. Ms. Uma understood our plight and said she will try her best to get it done asap, to save us the trouble. Also the technical team of Ramki and Ganesh were kind enough to take up the job on priority and completed the service quickly and handed over the camera and lens.",
    },
    {
      name: "Aashika Ajit",
      designation: "Nature Photographer",
      src: `https://ui-avatars.com/api/?name=A&background=random&size=256`,
      rating: 5,
      quote:
        "Their service is good and they are polite and friendly. Very attentive towards customers and their satisfaction. Their was of handling situations are also pretty good. They give you an accurate diagnosis and product for your need and they let you know when exactly you can pick your stuff up. Their service price is also very legible.",
    },
    {
      name: "Joshi Digital Studio",
      designation: "Studio Photographer",
      src: `https://ui-avatars.com/api/?name=J&background=random&size=256`,
      rating: 5,
      quote:
        "We are coming from kadapa dist, Ap. My camera and two lenses got serviced within 5 hours. Excellent service at reasonable charge. I will never go to any other service centre. Iam very happy to see my camera now.",
    },
    {
      name: "Tightframe Photography",
      designation: "Professional Photographer",
      src: `https://ui-avatars.com/api/?name=T&background=random&size=256`,
      rating: 5,
      quote:
        "Excellent experience. The staff team is very pleasant to deal with. I had gone to them with a specific issue of fungus in my lens outer element. Mr Kamlesh who is incharge of Nikon service centre is experienced in handling camera accessories. I felt very confident getting my lens serviced by him, they returned it in QuickTime and was very satisfied with their work. I had my next shoot using my lens with great results.",
    },
    {
      name: "Chandru",
      designation: "Photographer",
      src: `https://ui-avatars.com/api/?name=C&background=random&size=256`,
      rating: 5,
      quote:
        "Best service ever. Very professional. Specifics of the technical elements. They have been taking good care of customers from start to end. In particular, Mrs. Uma treats customers with professionalism and consideration.",
    },
  ];

  return (
    <div className="py-20">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center mb-12"
      >
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="text-4xl font-bold mb-4"
        >
          What Our Customers Say
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="flex items-center justify-center gap-1 mb-6"
        >
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="w-6 h-6 text-yellow-400 fill-yellow-400" />
          ))}
        </motion.div>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="text-muted-foreground max-w-2xl mx-auto"
        >
          Trusted by photographers across South India for over four decades.
          Read what our valued customers have to say about their experience with
          us.
        </motion.p>
      </motion.div>
      <AnimatedTestimonials testimonials={testimonials} />
    </div>
  );
}
